import { dateToString } from "utils/dateUtils";
import {
    getAsync as _getAsync,
    updateAsync as _updateAsync,
    addAsync as _addAsync,
    deleteAllAsync as _deleteAllAsync,
} from "../../api";

const BASE_URL = (trnFlowTaskId) => `/flow-tasks/${trnFlowTaskId}/comments`;

function normalizeTaskData(data) {
    const { date: dateInMillis } = data;

    const date = dateInMillis && new Date(dateInMillis);

    return {
        ...data,
        date,
        dateString: dateToString(date),
    };
}

export function normalizeTasks(tasks) {
    return tasks.map((d) => normalizeTaskData(d));
}

export async function getAllByTaskAsync({ trnFlowTaskId }) {
    return _getAsync({
        url: `${BASE_URL(trnFlowTaskId)}/by-task`,
        normalizer: normalizeTasks,
    });
}

export async function addForTaskAsync({ trnFlowTaskId, payload }) {
    return _addAsync({ url: `${BASE_URL(trnFlowTaskId)}/for-task`, data: payload });
}

export async function updateForTaskAsync({ trnFlowTaskId, payload }) {
    return _updateAsync({ url: `${BASE_URL(trnFlowTaskId)}/for-task/${payload.id}`, data: payload });
}

export async function deleteForTaskAsync({ trnFlowTaskId, id }) {
    return _deleteAllAsync({ url: `${BASE_URL(trnFlowTaskId)}`, data: {ids: [id]} });
}
